/**
 * The app language as plain-JS code can read it. The I18nProvider is the owner of the language
 * (React state + localStorage); it mirrors every change here synchronously, so non-React helpers
 * such as utils/dateUtils.js format with the language the patient chose, not the device locale
 * and not a hard-coded 'en-US' (PROD-814). Pure module, no imports.
 */
const LOCALE_BY_LANGUAGE = { en: 'en-US', es: 'es-US' }

let current = 'en'

export const setAppLanguage = (code) => { current = typeof code === 'string' && code ? code : 'en' }
export const getAppLanguage = () => current

/** BCP-47 locale for a language code; an unknown language falls back to 'en-US'. */
export const appLocale = (code = current) =>
  Object.prototype.hasOwnProperty.call(LOCALE_BY_LANGUAGE, code) ? LOCALE_BY_LANGUAGE[code] : 'en-US'
